import {ChangeDetectionStrategy, Component, Injectable, signal} from '@angular/core';
import {AvtaleModell, AvtaleRessursClient} from 'felles-ng2/tjenester/ressurser/generertNg2HttpKlient';
import {AdministrasjonAvtaleKomponent} from '../administrasjon-avtale/administrasjon-avtale';
import {AdministrasjonNavigasjonKomponent} from '../administrasjon-navigasjon/administrasjon-navigasjon';

@Component({
    selector: 'administrasjon-avtaler-side',
    templateUrl: 'administrasjon-avtaler-side.html',
    styleUrl: 'administrasjon-avtaler-side.scss',
    host: {'data-testid': 'administrasjon-avtaler-side'},
    imports: [AdministrasjonNavigasjonKomponent, AdministrasjonAvtaleKomponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdministrasjonAvtalerSideKomponent {
    static ajsSelector = 'administrasjonAvtalerSide';

    readonly avtaler = signal<AvtaleModell[]>([]);

    constructor(private avhengigheter: AdministrasjonAvtalerSideAvhengigheter) {
        void this.lastAvtaler();
    }

    async lastAvtaler(): Promise<void> {
        this.avtaler.set(await this.avhengigheter.finnAlle());
    }

    vedAvtaleOppdatert(oppdatert: AvtaleModell): void {
        this.avtaler.update(avtaler => avtaler.map(avtale => avtale.id === oppdatert.id ? oppdatert : avtale));
    }
}

@Injectable({providedIn: 'root'})
export class AdministrasjonAvtalerSideAvhengigheter {
    constructor(private avtaleRessurs: AvtaleRessursClient) {}

    finnAlle(): Promise<AvtaleModell[]> {
        return this.avtaleRessurs.finnAlle().somPromise();
    }
}
